import { render } from "./Technology.vue?vue&type=template&id=3ffe3386&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"

import "./Technology.vue?vue&type=style&index=0&id=3ffe3386&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ffe3386"

export default script